import { makeStyles } from "@material-ui/core";
import styled from "styled-components";

const drawerWidth = 284;
export const useStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  containerLocal: {
    display: "flex",
    flexDirection: "column",
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
    alignItems: "center",
  },
  root: {
    width: "100%",
    maxWidth: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: "inline",
  },
  rootSideBar: {},
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  hide: {
    display: "none",
  },
  drawerPaper: {
    display: "flex",
    borderRadius: "0px 20px 20px 0px",
    position: "absolute",
    height: "calc(100vh - 56px)!important",
    width: drawerWidth,
    border: "none",
    backgroundColor: "transparent",
    boxShadow: "none",
    bottom: 0,
    top: "unset!important",
  },
  backdropProps: {
    background: "transparent",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
    backgroundColor: "#333333",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  ul: {
    color: "white",
    textDecoration: "none",
  },
  whiteIcon: {
    color: "white",
  },
}));

export const Small = styled.small`
  font-size: 14px;
  margin-left: 8px;
  font-family: "Graphik-Regular";
`;
